import React from "react";
import { Link } from "react-router-dom";
import "./CarrerPageCard.scss";

function CarrerPageCard({ fontBold, data, fontColor }) {

  return (
    <div className="my-4">
      <div className="card-container">
        <div>
          <h2
            className="section-title"
            style={fontBold}
          >
            {data?.jobTitle}
            
          </h2>
          <h2 className="section-profile-text">
           {data?.jobProfile}
          </h2>
          <div className="section-content">
            {data?.location ? (
              <p>Location: {data?.location}</p>
            ) : (
              ""
            )}
            {data?.positionType ? (
              <p>Position Type: {data?.positionType}</p>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="section-button">
          <Link
            state={{
              externalId: data?.externalId,
            }}
            to={`/application/${data.externalId}/${data.jobTitle.trim().replaceAll(' ', '-').toLowerCase()}-jobs-in-${data.location.trim().replaceAll(' ', '-').toLowerCase()}`}
          >
            <button className="card-button">Job Details
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px">
                <path fill="#444" d="M11.998,23.997 C5.381,23.997 -0.001,18.614 -0.001,11.998 C-0.001,5.382 5.381,-0.001 11.998,-0.001 C18.614,-0.001 23.997,5.382 23.997,11.998 C23.997,18.614 18.614,23.997 11.998,23.997 ZM11.998,2.181 C6.584,2.181 2.180,6.585 2.180,11.998 C2.180,17.412 6.584,21.815 11.998,21.815 C17.411,21.815 21.815,17.412 21.815,11.998 C21.815,6.585 17.411,2.181 11.998,2.181 ZM17.368,12.415 C17.312,12.548 17.232,12.669 17.131,12.770 L12.769,17.132 C12.556,17.346 12.277,17.452 11.998,17.452 C11.718,17.452 11.439,17.346 11.226,17.132 C10.800,16.706 10.800,16.016 11.226,15.590 L13.728,13.089 L7.634,13.089 C7.032,13.089 6.543,12.600 6.543,11.998 C6.543,11.396 7.032,10.907 7.634,10.907 L13.728,10.907 L11.226,8.406 C10.800,7.980 10.800,7.289 11.226,6.863 C11.652,6.437 12.343,6.437 12.769,6.863 L17.131,11.226 C17.232,11.327 17.312,11.447 17.368,11.581 C17.478,11.848 17.478,12.148 17.368,12.415 Z"></path>
              </svg>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CarrerPageCard;
